import { render, staticRenderFns } from "./ConvoPreview.vue?vue&type=template&id=2de7421d&scoped=true&"
import script from "./ConvoPreview.vue?vue&type=script&lang=js&"
export * from "./ConvoPreview.vue?vue&type=script&lang=js&"
import style0 from "./ConvoPreview.vue?vue&type=style&index=0&id=2de7421d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de7421d",
  null
  
)

export default component.exports